export const DEFAULT_HIGHRES_CONFIG = {
    format: 'webp',
    quality: 95,
    resolution: '4k',
    progressive: true,
    chunkSize: 64000,
};
export const DEFAULT_MODEL_VIDEO_CONFIG = {
    resolution: '4k',
    maxBitrate: 50000, // 50 Mbps - enough for 4K at high frame rates
    prioritizeResolution: true, // Never reduce resolution, only reduce bitrate/framerate if needed
};
export const DEFAULT_PARTICIPANT_CONFIG = {
    resolution: { width: 320, height: 180 },
    frameRate: { ideal: 10, max: 15 },
    adaptiveUpscale: true,
    maxResolution: { width: 640, height: 360 },
    pauseWhenModelFrameLoading: true,
};
//# sourceMappingURL=media.types.js.map